import { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { DEFAULT_THEME_COLOR, normalizeThemeColor } from '../theme/themeColors.js';

const ThemeModeContext = createContext(null);

export function ThemeModeProvider({ children }) {
  const [mode, setMode] = useState(() => localStorage.getItem('garmenterp_theme') || 'light');
  const [primaryColor, setPrimaryColorState] = useState(
    () => normalizeThemeColor(localStorage.getItem('garmenterp_theme_color') || DEFAULT_THEME_COLOR)
  );

  const toggleMode = useCallback(() => {
    setMode((current) => {
      const next = current === 'light' ? 'dark' : 'light';
      localStorage.setItem('garmenterp_theme', next);
      return next;
    });
  }, []);

  const setPrimaryColor = useCallback((color) => {
    const next = normalizeThemeColor(color);
    localStorage.setItem('garmenterp_theme_color', next);
    setPrimaryColorState(next);
  }, []);

  const value = useMemo(
    () => ({ mode, toggleMode, primaryColor, setPrimaryColor }),
    [mode, primaryColor, setPrimaryColor, toggleMode]
  );
  return <ThemeModeContext.Provider value={value}>{children}</ThemeModeContext.Provider>;
}

export function useThemeMode() {
  const context = useContext(ThemeModeContext);
  if (!context) throw new Error('useThemeMode must be used within ThemeModeProvider');
  return context;
}
